/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Improve_Protein_WhyInputs */

const en_us2_improve_protein_why = /** @type {(inputs: Improve_Protein_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protein sets how fast muscle can grow. We use it to set expectations, not sets.`)
};

const pt_br2_improve_protein_why = /** @type {(inputs: Improve_Protein_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A proteína define a velocidade do ganho. Usamos para ajustar expectativas, não séries.`)
};

const es_419_improve_protein_why = /** @type {(inputs: Improve_Protein_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La proteína define qué tan rápido crece el músculo. La usamos para ajustar expectativas, no series.`)
};

const pt_pt2_improve_protein_why = /** @type {(inputs: Improve_Protein_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A proteína define a velocidade do ganho. Usamo-la para ajustar expectativas, não séries.`)
};

const fr_fr2_improve_protein_why = /** @type {(inputs: Improve_Protein_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les protéines déterminent la vitesse de prise de muscle. On s'en sert pour ajuster les attentes, pas les séries.`)
};

const de_de2_improve_protein_why = /** @type {(inputs: Improve_Protein_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eiweiß bestimmt, wie schnell Muskeln wachsen können. Wir nutzen es für die Erwartungen, nicht für die Sätze.`)
};

const it_it2_improve_protein_why = /** @type {(inputs: Improve_Protein_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le proteine decidono la velocità di crescita muscolare. Le usiamo per calibrare le aspettative, non le serie.`)
};

/**
* | output |
* | --- |
* | "Protein sets how fast muscle can grow. We use it to set expectations, not sets." |
*
* @param {Improve_Protein_WhyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const improve_protein_why = /** @type {((inputs?: Improve_Protein_WhyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Improve_Protein_WhyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_improve_protein_why(inputs)
	if (locale === "es-419") return es_419_improve_protein_why(inputs)
	if (locale === "pt-PT") return pt_pt2_improve_protein_why(inputs)
	if (locale === "fr-FR") return fr_fr2_improve_protein_why(inputs)
	if (locale === "de-DE") return de_de2_improve_protein_why(inputs)
	if (locale === "it-IT") return it_it2_improve_protein_why(inputs)
	return en_us2_improve_protein_why(inputs)
});
export { improve_protein_why as "improve.protein.why" }